import Alpine from 'alpinejs';

Alpine.store('_product', window.product || {});

Alpine.store('_variant', window.variant || {});

Alpine.store('_cart', {
  data: window.cart || {},
  async refreshCart() {
    return fetch(Alpine.store('_shopify').routes.root + 'cart.js')
      .then((response) => response.json())
      .then((cart) => {
        this.data = cart;
        window.dispatchEvent(new CustomEvent('cart:refreshed', { detail: this }));
      });
  },

  async addProduct(productId, quantity = 1) {
    window.dispatchEvent(new CustomEvent('cart:adding-product', { detail: { productId, quantity } }));

    return fetch(Alpine.store('_shopify').routes.root + 'cart/add.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({
        items: [
          {
            id: productId,
            quantity: quantity,
          },
        ],
      }),
    })
      .then((response) => response.json())
      .then((cart) => {
        return this.refreshCart().then(() => {
          let item = cart.items.find((i) => i.id === productId);
          window.dispatchEvent(new CustomEvent('cart:product-added', { detail: item }));
        });
      });
  },

  async removeProduct(lineItemId) {
    window.dispatchEvent(new CustomEvent('cart:removing-product', { detail: { lineItemId } }));

    return this.updateProductQuantity(lineItemId, 0);
  },

  async updateProductQuantity(lineItemId, quantity = 1) {
    window.dispatchEvent(new CustomEvent('cart:updating-product', { detail: { lineItemId, quantity } }));

    return fetch(Alpine.store('_shopify').routes.root + 'cart/change.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({
        id: lineItemId,
        quantity: quantity,
      }),
    })
      .then((response) => response.json())
      .then(() => {
        this.refreshCart().then(() => {
          if (quantity === 0) {
            window.dispatchEvent(new CustomEvent('cart:product-removed', { detail: item }));
          } else {
            let item = this.data.items.find((i) => i.key === lineItemId);
            window.dispatchEvent(new CustomEvent('cart:product-updated', { detail: item }));
          }
        })
      });
  },

  async clearCart() {
    window.dispatchEvent(new CustomEvent('cart:clearing'));

    return fetch(Alpine.store('_shopify').routes.root + 'cart/clear.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
    })
      .then((response) => response.json())
      .then(() => {
        this.refreshCart().then(() => {
          window.dispatchEvent(new CustomEvent('cart:cleared'));
        })
      });
  },
});

window.Shopify.countryData = window.countryProvinceData;
Alpine.store('_shopify', window.Shopify);
